import { useEffect, useState } from "react";
import {
  getPushPermission,
  isPushSupported,
  subscribeToPush,
  unsubscribeFromPush,
  sendTestPush,
} from "../../../utils/pushNotifications";
import { Button, useToast } from "../../ui";
import s from "./clientApp.module.css";

export default function ClientPushSettings() {
  const toast = useToast();
  const [permission, setPermission] = useState("default");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isPushSupported()) {
      getPushPermission().then(setPermission);
    } else {
      setPermission("unsupported");
    }
  }, []);

  if (permission === "unsupported") {
    return (
      <p className={s.profileMuted}>
        Push-уведомления недоступны в этом браузере. Установите приложение на
        телефон через Chrome или Safari.
      </p>
    );
  }

  const enabled = permission === "granted";

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await unsubscribeFromPush();
        setPermission(Notification.permission);
        toast.success("Push-уведомления отключены");
      } else {
        await subscribeToPush();
        setPermission("granted");
        toast.success("Push-уведомления включены");
      }
    } catch (e) {
      const msg =
        e.response?.status === 503
          ? "Push не настроен на сервере (VAPID-ключи)"
          : e.response?.data?.error || e.message || "Не удалось изменить настройки";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  const test = async () => {
    setBusy(true);
    try {
      await sendTestPush();
      toast.success("Тестовое уведомление отправлено");
    } catch (e) {
      toast.error(
        e.response?.status === 503
          ? "Push не настроен на сервере"
          : e.response?.data?.error || e.message || "Ошибка",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <p className={s.profileMuted}>
        {enabled
          ? "Вы получаете напоминания о тренировках за 4 часа до начала, опросы о явке, изменения расписания, новости и реакции в «Жизни клуба»."
          : "Включите уведомления, чтобы не пропускать тренировки, опросы и новости клуба."}
      </p>
      <div className={s.pushSettingsActions}>
        <Button type="button" onClick={toggle} disabled={busy} variant={enabled ? "secondary" : "primary"}>
          {busy ? "…" : enabled ? "Отключить push" : "Включить push"}
        </Button>
        {enabled ? (
          <Button type="button" variant="ghost" onClick={test} disabled={busy}>
            Тест
          </Button>
        ) : null}
      </div>
    </div>
  );
}
